var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 12L16.7071 12.7071L17.4142 12L16.7071 11.2929L16 12ZM4 11C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13V12V11ZM10 18L10.7071 18.7071L16.7071 12.7071L16 12L15.2929 11.2929L9.29289 17.2929L10 18ZM16 12L16.7071 11.2929L10.7071 5.29289L10 6L9.29289 6.70711L15.2929 12.7071L16 12ZM16 12V11H4V12V13H16V12Z","fill":"currentColor"}));
}

ArrowRight.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
